import { useTranslation } from 'react-i18next';

import { SystemRoutePath } from 'applications/GSP/shared/constants/router';

import type { RouteObject } from 'shared/types';

export const useSystemRoutesConfig = (): RouteObject[] => {
  const { t } = useTranslation();

  return [
    {
      path: SystemRoutePath.PrivacyNotice,
      handle: {
        crumb: t('GSP.layouts.mainLayout.header.breadcrumbs.privacyNotice'),
      },
      lazy: () =>
        import('applications/GSP/pages/PrivacyNotice').then(
          ({ PrivacyNotice }) => ({
            Component: PrivacyNotice,
          }),
        ),
    },
    {
      path: SystemRoutePath.CookiesPolicy,
      handle: {
        crumb: t('GSP.layouts.mainLayout.header.breadcrumbs.cookiesPolicy'),
      },
      lazy: () =>
        import('applications/GSP/pages/CookiesPolicy').then(
          ({ CookiesPolicy }) => ({
            Component: CookiesPolicy,
          }),
        ),
    },
    {
      path: SystemRoutePath.TermsOfUse,
      handle: {
        crumb: t('GSP.layouts.mainLayout.header.breadcrumbs.termsOfUse'),
      },
      lazy: () =>
        import('applications/GSP/pages/TermsOfUse').then(({ TermsOfUse }) => ({
          Component: TermsOfUse,
        })),
    },
  ];
};
